import React from 'react';
import classNames from 'classnames';
import { EnterpriseMember } from 'models/Enterprises';
import utils from 'utils';
import PencilIcon from 'icons/Pencil.icon';
import { Button } from 'ncoded-component-library';
import ArrowrightIcon from 'icons/Arrowright.icon';
import BuildingIcon from 'icons/Building.icon';
import PhoneIcon from 'icons/Phone.icon';
import MailIcon from 'icons/Mail.icon';
import { ReactComponent as LinkedInIcon } from 'icons/linkedin.svg';
import ResolveImage from 'components/ResolveImage';
import Avatar from 'assets/images/no-img-avatar.webp';
import { useTranslation } from 'react-i18next';
import { formatPhoneNumber } from 'phoneNumberUtils';

import './MemberInfo.styles.scss';
import './MemberInfo.styles.responsive.scss';

type MemberInfoProps = {
  className?: string;
  member: Partial<EnterpriseMember>;
  onEdit: () => void;
  onNext: () => void;
};

const MemberInfo: React.FC<MemberInfoProps> = (props) => {
  const { member, className, onEdit, onNext } = props;

  const classes = classNames('member-info', className);

  const formattedPhone = formatPhoneNumber(member?.user?.phone);
  const { linkedinUrl, vanityName } = utils.getLinkedinUrlAndVanityName(
    member?.user?.linkedinAccount,
  );

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <div className="member-info__title">
        <h1>{t('welcome')}</h1>
        <p>{t('pleaseConfirmDetails')}</p>
      </div>

      <div className="white-panel">
        <div className="data">
          <div>
            <p className="full-name">{`${member?.firstName} ${member?.lastName}`}</p>
            <p className="title">{member?.title}</p>
          </div>

          <div className="additional-info">
            <p>
              <BuildingIcon />
              <span>{member?.enterprise?.brandName}</span>
            </p>
            {formattedPhone && (
              <p>
                <PhoneIcon />
                <span>{formattedPhone}</span>
              </p>
            )}
            {member?.email && (
              <p>
                <MailIcon />
                <span>{member?.email}</span>
              </p>
            )}
            {linkedinUrl && (
              <p>
                <LinkedInIcon />
                <span>{vanityName}</span>
              </p>
            )}
          </div>
        </div>

        <ResolveImage src={member?.profileImage?.url || Avatar} asAvatar />
      </div>

      <div className="actions">
        <Button variant="link" icon={PencilIcon} onClick={onEdit}>
          {t('edit')}
        </Button>
        <Button onClick={onNext} icon={ArrowrightIcon} iconPosition="right">
          {t('confirm')}
        </Button>
      </div>
    </div>
  );
};

export default MemberInfo;
